import { render, staticRenderFns } from "./nav-dropdown-minimal.vue?vue&type=template&id=1e852316&"
import script from "./nav-dropdown-minimal.vue?vue&type=script&lang=js&"
export * from "./nav-dropdown-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports